import { PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@/contexts/authContext';
import { PRIVATE_ROUTES } from '@/routes/routes';

const PublicRoute = ({ children }: PropsWithChildren) => {
  const { auth } = useContext(AuthContext);
  const { idToken } = auth;

  if (idToken) {
    return <Navigate to={PRIVATE_ROUTES.APP} />;
  }

  return <>{children}</>;
};

export default PublicRoute;
